import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { COUNTRY_CODE } from '@core/enums';
import { GetCountryService } from '@core/services';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'fdsCurrency',
  standalone: true
})
export class FdsCurrencyPipe implements PipeTransform {
  codeCountry = '';
  withDecimals = false;
  preferredLanguage!: string;
  readonly #getCountryService = inject(GetCountryService);

  #getCurrencyConfig(): IconfigCurrency {
    switch (this.#getCountryService.getCountry()) {
      case COUNTRY_CODE.BRAZIL:
        this.codeCountry = 'BRL';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.ARGENTINA:
        this.codeCountry = 'ARS';
        break;
      case COUNTRY_CODE.CHILE:
        this.codeCountry = 'CLP';
        break;
      case COUNTRY_CODE.COLOMBIA:
        this.codeCountry = 'COP';
        break;
      case COUNTRY_CODE.ECUADOR:
        this.codeCountry = 'USD';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.VENEZUELA:
        this.codeCountry = 'VEF';
        break;
      case COUNTRY_CODE.PERU:
        this.codeCountry = 'PEN';
        this.withDecimals = true;
        break;
    }

    return {
      currency: this.codeCountry,
      maximumFractionDigits: this.withDecimals ? 2 : 0
    }
  }

  #getFormatedPrice(price: number): string {
    const configCurrency = this.#getCurrencyConfig();
    this.preferredLanguage = localStorage.getItem('@Ford-lang') as string;

    if (!price) return '';

    const formattedValue = price.toLocaleString(this.preferredLanguage, {
      style: 'currency',
      currency: configCurrency.currency,
      maximumFractionDigits: configCurrency.maximumFractionDigits,
    });
    return formattedValue;
  }

  transform(price: number | undefined): string {
    if (!price) return '';
    return this.#getFormatedPrice(price);
  }

}

interface IconfigCurrency {
  currency: string;
  maximumFractionDigits: number
}
